var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-2 text-xs italic text-red-500"},[_vm._v(" "+_vm._s(_vm.errors[0])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }